import { ReactiveControlsValidator } from '../extensions/form-validator';
import { FormBuilder, FormControl } from '@angular/forms';

export abstract class ReactiveControlValidator {
  public abstract formControl: FormControl;
  public abstract initReactiveForms(): void;

  constructor(protected formBuilder: FormBuilder) {
    this.initReactiveForms();
  }

  isInvalidControl(): boolean {
    return ReactiveControlsValidator.validateControl(this.formControl);
  }

  isValidControl(): boolean {
    return this.formControl.valid;
  }

  markControlAsTouched(): void {
    ReactiveControlsValidator.markControlAsTouched(this.formControl);
  }
}
